import { GradedUnit } from './graded-unit.model';

export class GradedUnitCommand {
    name: string;
    weight: number;
    graded_module: {
        id: string;
    };

    constructor(gradedUnit: GradedUnit) {
        this.name = gradedUnit.name;
        this.weight = gradedUnit.gradeWeight;
        this.graded_module = {
            id: gradedUnit.module.id,
        };
    }
}
